export default {
  EXPECTED: 'Estimated',
  DELIVERYDATE: 'Delivery',
  SELECTED: 'Selected',
  PRICESPIKE: 'Flash Sale Price',
  CSF: 'Import Fee',
  SHIPPINGFEE: 'Shipping Fee ',
  WECHATPAY: 'WeChat Pay',
  PROMOTION_DISCOUNT: 'Promo saved',
  AUTHENTICITY_GUARANTEE: 'Authenticity guarantee',
  AMOUNT_TO: 'Total',
  PAY_NOW: 'Pay now',
  DEFAULT: 'Default',
  MOBILE_NUMBER: 'Phone number',
  KYC: 'Buyer',
  SELECT_KYC: 'Select Purchaser',
  DELETE_SUCCESSFULLY: 'Deleted successfully',
  DELETE_FAILED: 'Deletion Failed',
  PLEASE_SELECT: 'Please Select',
  PURCHASE_CLAIM_THE_COUPON: 'After coupon',
  PURCHASE_IMMEDIATELY: 'Buy Now',
  CONSIGNEE_NAME: "Recipient's name",
  PAYMENT_SUCCESSFUL: 'Paid successfully',
  VIEWORDER: 'View order',
  AUTHORIZATION_SUCCESSFUL: 'Authorized successfully',
  REORDER: 'Reorder',
  PAYMENT_RESULTS: 'Payment Result',
  AUTHORIZE_NOW: 'Authorize Now',
  CANCEL_FILLING: 'Cancel',
  PROVIDE_YOU: '2. Provide Your',
  COUPON_DEDUCTION: 'Saving',
  CSF_DESCRIPTION: 'Import Service Fee Explanation',
  I_UNDERSTAND: 'I Understand',
  UPDATE_NOW: 'Update Now',
  CONFIRM_ORDERS: 'Confirm order',
  BUY_NOW_OR_MISS_OUT: 'Only {TOTAL} left in stock - order soon',
  PLEASE_PROVIDE_KYC: 'Please Fill in the Purchaser',
  PLEASE_PROVIDE_THE_ADDRESS_INFO: 'Enter Detailed Address',
  NAME_DO_NOT_EXCEED_20_WORDS:
    "Recipient's Name Should Not Exceed 20 Characters",
  ADDRESS_DO_NOT_EXCEED_100_WORDS:
    'Detailed Address Should Not Exceed 100 Characters',
  DOTD_DISCOUNTED_PRICE: 'Deal price',
  CHINESE_CUSTOMER_SERVICE: 'Chinese Customer Service',
  NOT_ELIGIBLE_FOR_UNCONDITIONAL_RETURN: 'Ineligible for return',
  PRODUCT_NOT_ELIGIBLE_FREE_SHIPPING_OVER_300RMB:
    'Ineligible for free shipping over ¥300',
  TOTAL_AMOUNT_OF_PRODUCTS: 'Items',
  UNABLE_PROVIDE_INVOICES_GLOBAL_STORE_PURCHASES:
    'Invoice unavailable for Global Store purchase',
  CONFIRM_ORDER_CONTAINS_UNSUPPORTED_UNCONDITIONAL_RETURN:
    'Confirm the order containing items ineligible for return within 30 days of receipt',
  SAVED_ON_SHIPPING_FEES: 'Shpg saved',
  PLEASE_CHECK_THE_BOX_AT_THE_BOTTOM_OF_THE_PAGE:
    'Please Check the Order Confirmation at the Bottom of the Page',
  ADD_KYC_CUSTOMS_CLEARANCE_INFO: "Add buyer's ID",
  ADD_KYC_INFO: 'Add buyer',
  EDIT_KYC_CUSTOMS_CLEARANCE_INFO:
    "Edit Purchaser's Customs Clearance Information",
  TIPS_FOR_GLOBAL_STORE_SHOPPING: 'Global Store purchase tips',
  REAL_NAME_PAYMENT_VERIFICATION_FAILED_ORDER_CANCELED:
    "To purchase cross-border products  customs declaration and real-name verification are required. Please add customs clearance information for the purchaser consistent with the name of the order payer. If the purchaser's name does not match the order payer's name (WeChat account holder)  the order will be canceled.",
  ADD_CONSIGNEE_KYC: "Submit Recipient's Customs Clearance Information",
  ADD_KYC_INFO_WHEN_CLEARANCE:
    'To purchase cross-border products  customs declaration and real-name verification are required. Please add customs clearance information for the order recipient.',
  KYC_SUBMIT_SUCCESS:
    'ID Information Submitted Successfully  Customs Processing in Progress',
  ID_CARD_NAME: 'ID name',
  ID_CARD_NUMBER: 'ID number',
  ID_CARD_NUM: 'ID number',
  TAIL_NUMBER: 'last digits',
  NO_KYC_PLEASE_ADD: 'No ID Information,  Please Add',
  NO_KYC: 'No Purchaser Information',
  MANAGE_KYC_INFO: 'Manage customs clearance Information',
  SAVE_AND_APPLY: 'Save and apply',
  SELECT_SHIPPING_ADDRESS: 'Select Shipping Address',
  PLEASE_FILL_SHIPPING_ADDRESS: 'Please Fill in the Shipping Address',
  NO_SHIPPING_ADDRESS_FOUND_PLEASE_ADD: 'No shipping address, please add',
  NO_SHIPPING_ADDRESS: 'No Shipping Address',
  ADD_SHIPPING_ADDRESS: 'Add shipping address',
  EDIT_SHIPPING_ADDRESS: 'Edit Shipping Address',
  PLEASE_FILL_SHIPPING_ADDRESS_FIRST:
    'Please Fill in the Shipping Address First',
  SET_AS_DEFAULT: 'Set as default',
  SET_UP_SUCCESSFULLY: 'Setting Successful',
  ADDRESS_SAVED_SUCCESSFULLY: 'Saved successfully',
  SAVE_KYC_SUCCESS: 'Saved successfully',
  SUBMISSION_FAILED_PLEASE_RESUBMIT: 'Submission Failed ,Please Resubmit',
  MANAGE_SHIPPING_ADDRESSES: 'Manage shipping address',
  THIS_ORDER_SAVES_YOU: 'Savings for this order',
  YOUR_ORDER_PAYMENT_FAILED: 'Your Order Payment Failed',
  ORDERER_AND_PAYER_SHOULD_BE_SAME:
    "When using buyer's customs clearance information, please ensure the selected buyer's name matches the Order payer's name (WeChat Account holder)  otherwise the order will Be canceled.",
  GLOBAL_STORE_NOTIFICATION_AND_ORDER_AUTHORIZATION:
    'Global Stores Purchase Notice and Order Authorization',
  CUSTOMER_AUTHENTICATION_ACKNOWLEDGE:
    "Amazon Global Store products are sold and shipped by Amazon websites outside of China. By placing an order for Global Store products  customers agree to the periodically updated and agree that the purchase is subject to the laws of the original Amazon website's sales location.",
  CUSTOMER_AUTHENTICATION_FOR_GS_PURCHASE:
    'To complete the purchase ,please check to agree to the following authorizations:',
  USAGE_CONDITIONS: 'Amazon Global Store Terms of Use',
  ALLOW_AMAZON_WEBSITES_COLLECT_USE_INFO_INCLUDING:
    "Agree to amazon.cn collecting and processing customer's name,  address  phone number ,and ID information, or ID photocopy for customs clearance or to comply with legal regulations including foreign exchange control.",
  INFO_WILL_USED_CLEARANCE_REAL_NAME_DECLARATION:
    "Agree to the Global Stores sales entity of Amazon Global Store  Amazon Export Sales LLC  obtaining customer's Amazon Global Store account information to fulfill customer orders.",
  CHANGE_AUTH_STATUS_IN_MY_AFTERWARDS:
    "In 'My' > 'Modify Global Store Permissions' you can change authorization status",
  ORDER_CAN_NOT_PAY_WITHOUT_AUTH:
    'Unable to complete order payment without full authorization',
  ONLY_X_ITEMS_LEFT_PRE_ORDER_QUICKLY:
    'Only {TOTAL} items left  hurry to pre-order',
  ORDER_SOON: 'order soon',
  PURCHASE_HAS_BEEN_AUTOMATICALLY_RESTRICTED:
    'Automatic Purchase Limit Adjusted Quantity',
  AMAZON_WILL_ESTIMATE_IMPORT_FEES_FOR_ORDER:
    'Amazon Global Store will estimate and collect relevant import taxes according to customs policy when you place an order',
  SHIPPING_FEE_DESCRIPTION: 'Shipping Fee Explanation',
  LOGISTICS_AND_DELIVERY_COSTS_INCURRED_ON_ORDER:
    'The actual logistics and delivery costs incurred after you place an order on Amazon Global Store',
  PRODUCTS_HAVE_BEEN_SOLD_OUT: 'Product Sold Out',
  SOME_PRODUCTS_SOLD_OUT_UPDATING_THE_ORDER:
    'Some Products Sold Out  Update Order to Continue Ordering',
  ORDER_HAS_BEEN_UPDATED: 'Order Updated',
  YOU_ARE_TOO_LATE: "You're Late",
  VIEW_OTHER_PRODUCTS: 'View Other Products',
  LOOK_OTHER_ASIN: 'Go Shop Other Products',
  SOME_DISCOUNTS_HAVE_BEEN_SOLD_OUT: 'Some Discounts Sold Out',
  UPDATING_ORDER_ALLOWS_YOU_CONTINUE_PLACING:
    'Update Order to Continue Ordering',
  PLEASE_CONFIRM_THE_PURCHASE_RESTRICTION: 'Please Confirm Purchase Limit',
  FAILED_TO_CREATE_THE_ORDER: 'Order creation failed',
  AUTOMATIC_PURCHASE_RESTRICTION_CONFIRMATION_SUCCESSFUL:
    'Automatic Purchase Limit Confirmation Successful',
  REDUCED_SHIPPING_FEE_FOR_ORDERS_OVER_THESHOLD: 'FREE Shipping',
  VIEW_AFTER_SELECTING_AN_ADDRESS: 'View After Selecting Address',
  NEWCOMER_COUPON_FOR_ALL_MERCHANTS: '',
  WECHAT_NOT_INSTALLED: 'WeChat Not Installed',
  PLEASE_INSTALL_WECHAT_FIRST:
    'You have not installed WeChat services  unable to complete payment  please install WeChat first.',
  PROMISE_DATE_UNKWON: 'Estimated Shipping Date Not Yet Determined',
  PLEASE_FILL_NAME_CONSIGNEE: "Please Enter Recipient's Name",
  PLEASE_DO_NOT_EXCEED_WORDS: 'Do Not Exceed {NUMS} Characters',
  PLEASE_USE_REAL_NAME: 'Please use your real name',
  FILL_MOBILE_NUMBER: 'Please Fill in Phone Number',
  LOCATION: 'Location',
  FILL_ADDRESS: 'Fill in address',
  ADDRESS: 'Detailed address',
  PROVINCE_CITY_DISTRICT_STREET: 'Province/City/District',
  PLEASE_FILL_ADDRESS: 'Street/Apartment/Unit/Room',
  SET_DEFAULT_ADDRESS: 'Set as Default Shipping Address',
  PLEASE_SELECT_REGION: 'Please Select Location',
  PLEASE_CLICK_BUTTON_FILL_SHIPPING_ADDRESS:
    "You don't have a shipping address yet, please fill in",
  PHONE_NUM_FORMAT_INCORRECT_RE_ENTER:
    'Phone Number Format Incorrect  Please Re-enter',
  SIZE_CHART: 'Size Chart',
  LARGE_IMAGE: 'Thumbnail',
  DIFFERENT_ASIN_TYPES_LIST: 'List',
  CURRENT_PRODUCT_AVAILABLE: 'Eligible for buy  ',
  ADD_CUSTOMER_KYC_INFO: 'Add Purchaser Information',
  PROVIDE_THE_KYC_INFO: 'Fill in purchaser',
  ONE_STEP_AWAY_FROM_ORDER: 'One More Step to Place Order',
  SAME_AS_ORDER_PAYER: "Same as buyer's name",
  ONLY_USED_FOR_CUSTOMER_CLEARANCE: 'Only for Global Store buyer ID',
  ID_CARD_NUM_FORMAT_INCORRECT_RE_ENTER:
    'ID number format incorrect, please re-enter',
  PLEASE_ENTER_ID_CARD_NAME: 'Please enter ID name',
  PLEASE_ENTER_ID_CARD_NUM: 'Please enter ID number',
  PLEASE_ENTER_MOBILE_NUMBER: 'Please enter phone number',
  FAILED_BIND_ID_CARD_TRY_AGAIN: 'Binding ID Failed  Please Retry',
  USUALLY_TAKES_A_FEW_DAYS_TO_ARRIVE:
    '4-12 days for Amazon international delivery',
  ID_CARD_IMAGE: 'ID photo',
  UPLOAD_FRONT_CITIZEN_PHOTO: 'Upload ID portrait side photo',
  UPLOAD_BACK_CITIZEN_PHOTO: 'Upload ID national emblem side photo',
  KYC_NAME_DO_NOT_EXCEED_20_WORDS: 'Name Should Not Exceed 20 Characters',
  SUCCESS_ADD_CART: 'Added to Shopping Cart',
  PHONE_ENCRYPTED_PLEASE_RE_ENTER: 'Phone Number Encrypted  Please Re-enter',
  ID_NUMBER_ENCRYPTED_PLEASE_RE_ENTER: 'ID Number Encrypted  Please Re-enter',
  PLEASE_UPLOAD_FRONT_CITIZEN_PHOTO: 'Please Upload ID portrait side photo',
  PLEASE_UPLOAD_BACK_CITIZEN_PHOTO:
    'Please upload ID national emblem side photo',
  ALREADY_AUTOMATIC_PURCHASE_RESTRICTION: 'Automatic Purchase Limit',
  ONLY_X_ITEMS_LEFT_PRE_ORDER_QUICKLY_BR:
    'Only {TOTAL} items left  hurry to pre-order',
  ADD_CONSIGNEE_KYC_TIP:
    "Policy Reminder: According to customs requirements  your order will be cleared as personal use items  you need to supplement the recipient's ID card front and back photos or scans  so that your goods can be smoothly cleared.",
  DOTD: "Today's deals",
  TODAY_DEAL: "Today's Deals",
  BEST_DEAL: 'Special Sales',
  FILL_INTERRUPT_PROMPT: 'Almost complete address filling',
  NEXT_TIME: 'Cancel',
  CONTINUE_FILLING: 'Continue filling',
  WAIT_PAYMENT_STATUS: 'Waiting for an update on the payment status',
  BEST_DEAL_PRICE: 'Special Sale Price',
  UPLOAD_SUCCESS: 'Successfully Uploaded',
  UPLOAD_FAILED: 'Upload Failed  Please Retry',
  SIZE_NAME: 'Size',
  COLOR_NAME: 'Color',
  FLAVOR_NAME: 'Flavor',
  STYLE_NAME: 'Style',
  SPECIAL_SIZE_TYPE: 'Special Size',
  CUSTOMER_PACKAGE_TYPE: 'Product Packaging Type',
  BAND_COLOR: 'Strap Color',
  EDITION: 'Version',
  ITEM_PACKAGE_QUANTITY: 'Number of Items in Product Packaging',
  CONFIGURATION: 'Configuration',
  MAXIMUM_PAYMENT_LIMIT_EXCEEDED: 'Exceeded Maximum Payment Limit',
  FAILED_TO_CREATE_ORDER: 'Order creation failed'
};
